/**
 * 바닥에 떨어지는 메소/아이템.
 * 원작처럼 튀어오른 뒤 정착하고, 일정 시간이 지나면 점멸하며 사라진다.
 */

import Phaser from 'phaser';
import type { AssetTable } from '../assets/loader';
import { DROPS } from '../data/balance';
import { ITEMS } from '../data/items';
import { DEPTH } from '../game/depth';

export type DropKind = { type: 'meso'; amount: number } | { type: 'item'; itemId: string };

export class Drop extends Phaser.Physics.Arcade.Sprite {
  readonly kind: DropKind;
  private bornAt: number;
  private blinkStarted = false;

  constructor(scene: Phaser.Scene, x: number, y: number, kind: DropKind, assets: AssetTable) {
    const texture = kind.type === 'meso' ? 'item-meso' : ITEMS[kind.itemId].texture;
    super(scene, x, y, texture, 0);
    this.kind = kind;
    this.bornAt = scene.time.now;

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.setOrigin(0.5, 1)
      .setDepth(DEPTH.drop)
      .setScale(assets.scaleFor(texture));

    const body = this.body as Phaser.Physics.Arcade.Body;
    const frame = assets.get(texture);
    body.setSize(frame.frameWidth * 0.7, frame.frameHeight * 0.6, false);
    body.setOffset(frame.frameWidth * 0.15, frame.frameHeight * 0.4);
    body.setVelocity(
      Phaser.Math.Between(-DROPS.popVelocity.x, DROPS.popVelocity.x),
      DROPS.popVelocity.y,
    );
    body.setDragX(400);
    body.setBounce(0.25, 0.3);

    scene.tweens.add({
      targets: this,
      angle: Phaser.Math.Between(-18, 18),
      duration: 380,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.InOut',
    });
  }

  get label(): string {
    return this.kind.type === 'meso'
      ? `${this.kind.amount} 메소`
      : (ITEMS[this.kind.itemId]?.name ?? '아이템');
  }

  override preUpdate(time: number, delta: number): void {
    super.preUpdate(time, delta);
    const age = time - this.bornAt;
    if (!this.blinkStarted && age > DROPS.lifetimeMs - 3000) {
      this.blinkStarted = true;
      this.scene.tweens.add({
        targets: this,
        alpha: 0.25,
        duration: 220,
        yoyo: true,
        repeat: -1,
      });
    }
    if (age > DROPS.lifetimeMs) this.destroy();
  }
}
